// extracted by mini-css-extract-plugin
module.exports = {"LabelInput":"LabelInput_LabelInput__1TsDa"};